// Utility function to update cart and notify components
export const updateCartInLocalStorage = (cartProducts) => {
  localStorage.setItem('cartProducts', JSON.stringify(cartProducts));
  // Dispatch custom event to notify Header component
  window.dispatchEvent(new Event('cartCountUpdate'));
};

// Utility function to get cart from localStorage
export const getCartFromLocalStorage = () => {
  try {
    return JSON.parse(localStorage.getItem('cartProducts')) || [];
  } catch {
    return [];
  }
};

// Utility function to clear cart
export const clearCart = () => {
  localStorage.removeItem('cartProducts');
  window.dispatchEvent(new Event('cartCountUpdate'));
  localStorage.removeItem('userDetails');
  localStorage.removeItem('customOrderId');
};